export enum AdminQueryKey {
	GetMeAdmin = 'admin.getme',
	GetOperators = 'admin.getOperators',
	GetOperatorById = 'admin.getOperatorById',
	GetDomains = 'admin.getDomains',
	SearchDomains = 'admin.searchDomains',
	GetDomainQuota = 'admin.getDomainQuota',
}

export enum AdminMutationKey {
	CreateOperator = 'admin.createOperator',
	UpdateOperator = 'admin.updateOperator',
	AttachDomain = 'admin.attachDomain',
	DetachDomain = 'admin.detachDomain',
	BuyDomain = 'admin.buyDomain',
}
